// extracted by mini-css-extract-plugin
export default {"box":"InfoBox_box__RK7lk","icon":"InfoBox_icon__p3GA0","text":"InfoBox_text__33ESn"};